<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		:class="iconColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.4349 10.0889H15.6319C15.6169 10.0889 15.6069 10.0966 15.5919 10.0966C15.5544 10.0992 15.5194 10.1095 15.4844 10.1198C15.4469 10.1301 15.4119 10.1404 15.3794 10.1584C15.3494 10.1739 15.3244 10.1945 15.2969 10.2151C15.2644 10.2383 15.2369 10.2641 15.2094 10.2924C15.1869 10.3182 15.1719 10.3465 15.1544 10.3774C15.1344 10.4135 15.1144 10.447 15.1019 10.4882C15.0969 10.5011 15.0869 10.5114 15.0844 10.5243L13.4967 16.7255L10.6238 0.479196C10.5738 0.20353 10.3413 0 10.0687 0C10.0662 0 10.0662 0 10.0637 0C9.79372 0 9.55869 0.198377 9.50618 0.471467L7.50843 10.9262L6.05575 5.25828C5.99074 5.00837 5.77322 4.83061 5.52319 4.82288C5.24565 4.80227 5.04563 4.98003 4.96812 5.22736L3.45043 10.0889H0.567571C0.255032 10.0889 0 10.3517 0 10.6737C0 10.9957 0.255032 11.2585 0.567571 11.2585H3.86298C4.11051 11.2585 4.32804 11.0936 4.40305 10.8541L5.45318 7.48937L7.04087 13.6829C7.10838 13.9456 7.35091 14.1414 7.60844 14.1183C7.87348 14.1105 8.09601 13.9147 8.14601 13.6468L10.0412 3.72794L12.8341 19.5208C12.8816 19.7913 13.1041 19.9897 13.3692 20C13.3767 20 13.3842 20 13.3917 20C13.6492 20 13.8742 19.8222 13.9392 19.5646L16.067 11.2611H19.4324C19.7449 11.2611 20 10.9983 20 10.6763C20.0025 10.3491 19.7475 10.0889 19.4349 10.0889Z"
			fill="currentColor"
		/>
	</svg>
</template>
<script setup>
const props = defineProps({
	iconColor:{
		type:String,
		default:'#2A8176'
	}
}
);
</script>
